import { EmailTextInput, FloatingFormItem } from '@/components/_common';
import { MailSendingForm } from '@/core/domain/mail/MailControler/MailControler.types';
import { useWorkOrder } from '@/core/domain/workorder/WorkOrders/WorkOrders.hooks';
import { ContactType } from '@/core/domain/_shared/ContactType';
import { useDefaultEmptyFieldError } from '@/hooks';
import flatContacts from '@/utils/functions/flatContacts';
import { AutoComplete, Form, FormInstance, Input } from 'antd';
import { useEffect } from 'react';
import { useCustomerContacts } from '@/core/domain/people/CustomerContacts/CustomerContacts.hooks';

type Props = {
  form: FormInstance<MailSendingForm>;
  isEdit?: boolean;
  workorderId?: number;
  extra?: React.ReactNode;
};

const MailSendForm: React.FC<Props> = ({
  isEdit,
  form,
  workorderId,
  extra,
}) => {
  const requiredRole = useDefaultEmptyFieldError();

  const { data: workorder } = useWorkOrder(workorderId);

  const customerContacts = useCustomerContacts(workorder?.customer?.id);

  const contacts = flatContacts(customerContacts.data).filter(
    (contact) => contact.contactType === ContactType.Email,
  );

  useEffect(() => {
    if (contacts.length) {
      form.setFieldValue('to', contacts[0]?.value);
    }
  }, [contacts]);

  return (
    <Form
      form={form}
      onValuesChange={(field: MailSendingForm) => {
        if (field.sendWorkorder === false) {
          form.setFieldValue('attachment', null);
        }
      }}
    >
      <Form.Item hidden name="fromName" noStyle>
        <Input disabled={isEdit} />
      </Form.Item>
      <Form.Item hidden name="attachment" noStyle>
        <Input />
      </Form.Item>

      <FloatingFormItem label="Para" name="to" rules={[requiredRole]}>
        <AutoComplete
          options={contacts.map((contact) => ({ value: contact.value }))}
          allowClear
          disabled={isEdit}
        />
      </FloatingFormItem>

      <FloatingFormItem label="Assunto" name="subject">
        <Input disabled={isEdit} />
      </FloatingFormItem>

      <Form.Item name="message">
        <EmailTextInput style={{ height: 300 }} readyOnly={isEdit} />
      </Form.Item>

      {!!extra && extra}
    </Form>
  );
};

export default MailSendForm;
